import {apiFetch} from "./General";

export const getCustomerSaid = (callback, errorCallback) => {

    apiFetch('customersaid', '', callback, errorCallback);
}
